import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/whoplays-web/whoplays-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/whoplays-web/whoplays-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["VenueDetailBackButton"] */ "/home/runner/work/whoplays-web/whoplays-web/src/components/venues/venue-detail-back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenueMediaCarousel"] */ "/home/runner/work/whoplays-web/whoplays-web/src/components/venues/venue-media-carousel.tsx");
